import { z } from 'zod';

export const bingoSets = ['numbers', 'music', 'logo', 'big_baubles'] as const;
export const bingoSetSchema = z.enum(bingoSets);
export type bingoSetType = z.infer<typeof bingoSetSchema>;

export const BingoValidationSchema = z.object({
	set: bingoSetSchema.default('numbers'),
});
export type BingoValidation = z.infer<typeof BingoValidationSchema>;
const bingoMappingSchema = z.record(bingoSetSchema, z.string());
type bingoMappingType = z.infer<typeof bingoMappingSchema>;
export const bingoMapping: bingoMappingType = {
	numbers: 'numbers',
	music: 'music',
	logo: 'logo',
	big_baubles: 'numbers',
};
export function bingoSetToPath(set: bingoSetType, index: number) {
	const baseDir = '/bingo/';
	return baseDir + bingoMapping[set] + '/' + index + '.webp';
}

export const bingoCardSchema = z.array(z.number()).min(25).max(25);
export type bingoCardType = z.infer<typeof bingoCardSchema>;
